import moment from 'moment';
import { declOfNum } from '../helpers';

export function isRequired(val, message) {
    const errorMessage = message || 'Поле не заполнено';

    if (val === null) {
        return errorMessage;
    }

    switch (typeof val) {
        case 'undefined':
            return errorMessage;
        case 'object':
            return Object.keys(val).length
                ? undefined
                : errorMessage;
        default:
            return val.toString().trim().length
                ? undefined
                : errorMessage;
    }
}

export function isRequiredObject(val, message) {
    const errorMessage = message || 'Поле не заполнено';

    if (val === null) {
        return errorMessage;
    }

    switch (typeof val) {
        case 'undefined':
            return errorMessage;
        case 'object':
            return Object.keys(val).length
                ? undefined
                : errorMessage;
        default:
            return errorMessage;
    }
}

export function isEmptyString(val) {
    return (typeof val !== 'string' && typeof val !== 'number') || !val.toString().length;
}

export function isEmail(val, message) {
    const errorMessage = message || 'Введите корректный email';

    switch (true) {
        case isEmptyString(val):
            return undefined;
        case hasCyrillic(val):
            return errorMessage;
        default:
            // https://stackoverflow.com/questions/46155/how-to-validate-email-address-in-javascript
            /* eslint:disable:no-useless-escape */
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/;
            /* eslint:enable:no-useless-escape */
            return re.test(val.trim())
                ? undefined
                : errorMessage;
    }
}

export function isCyrillicFio(val, message) {
    const errorMessage = message || 'Допустимо: кириллица, пробелы, точки и тире';

    switch (true) {
        case isEmptyString(val):
            return undefined;
        default:
            return /^[а-яё\-\.\s]+$/i.test(val.trim())
                ? undefined
                : errorMessage;
    }
}

export function isCyrillic(val, message) {
    const errorMessage = message || 'Поле может содержать ' +
        'только символы кириллицы';

    switch (true) {
        case isEmptyString(val):
            return undefined;
        default:
            return /^[а-яё]+$/i.test(val.trim())
                ? undefined
                : errorMessage;
    }
}

export function hasCyrillic(val) {
    return /[а-яё]/i.test(val.trim());
}

// +7 (987) 654-32-10
export function isPhone(val, message) {
    const errorMessage = message || 'Некорректный телефон';

    switch (true) {
        case isEmptyString(val):
            return undefined;
        default:
            return /^\+7\s\(\d{3}\)\s\d{3}-\d{2}-\d{2}$/.test(val.trim())
                ? undefined
                : errorMessage;
    }
}

export function isNumber(val, message) {
    const errorMessage = message || 'Поле может содержать только цифры';

    switch (true) {
        case isEmptyString(val):
            return undefined;
        default:
            return /^-?\d+$/.test(val.toString().trim())
                ? undefined
                : errorMessage;
    }
}

export function isLengthy(val, counts) {
    return val.trim().length === counts;
}

export function isMinLength(val, counts, message) {
    const errorMessage = message || `Минимальная длина ${counts} ` + declOfNum(counts, [
        'символ',
        'символа',
        'символов',
    ]);

    switch (true) {
        case isEmptyString(val):
            return undefined;
        default:
            return val.trim().length >= counts
                ? undefined
                : errorMessage;
    }
}

export function isMaxLength(val, counts, message) {
    const errorMessage = message || `Максимальная длина ${counts} ` + declOfNum(counts, [
        'символ',
        'символа',
        'символов',
    ]);

    return val.trim().length <= counts
        ? undefined
        : errorMessage;
}

export function isFullAge(date, message) {
    const errorMessage = message || 'Возраст проверяемого субъекта не может быть ниже 18 лет';

    switch (true) {
        case isEmptyString(date):
            return undefined;
        case isDate(date) !== undefined:
        case moment().diff(moment(date.trim(), 'DD/MM/YYYY'), 'years') < 18:
            return errorMessage;
        default:
            return undefined;
    }
}

export function isPostalCode(val, message) {
    const errorMessage = message || 'Поле может содержать только 6 цифр';

    switch (true) {
        case isEmptyString(val):
            return undefined;
        default:
            return /^\d{6}$/i.test(val.toString().trim())
                ? undefined
                : errorMessage;
    }
}
export function isPost (val, message) {
    const errorMessage = message || 'Должность может содержать только текст с пробелами, точками и запятыми';

    switch (true) {
        case isEmptyString(val):
            return undefined;
        default:
            return /^[-. ёЁ#№а-яА-Яa-zA-Z]+$/.test(val.toString().trim())
                ? undefined
                : errorMessage;
    }
}

export function isPassportNumber(val, message) {
    const errorMessage = message || 'Поле может содержать только 6 цифр';

    switch (true) {
        case isEmptyString(val):
            return undefined;
        default:
            return /^\d{6}$/i.test(val.toString().trim())
                ? undefined
                : errorMessage;
    }
}

export function isPassportSeries(val, message) {
    const errorMessage = message || 'Поле может содержать только 4 цифры';

    switch (true) {
        case isEmptyString(val):
            return undefined;
        default:
            return /^\d{4}$/i.test(val.toString().trim())
                ? undefined
                : errorMessage;
    }
}

export function isInnOrIndividualInn(val, message) {
    const errorMessage = message || 'ИНН может содержать только 10 цифр для компаний и 12 для ИП';

    switch (true) {
        case isEmptyString(val):
            return undefined;
        case /^\d+$/.test(val.toString()) === false:
            return errorMessage;
        default:
            return val.toString().length === 12 || val.toString().length === 10
                ? undefined
                : errorMessage;
    }
}

export function isInn(val, message) {
    function isCorrectINN(val) {
        // ((2n1+4n2+10n3+3n4+5n5+9n6+4n7+6n8+8n9) mod  11) mod  10 = 10th gigit
        const [n1, n2, n3, n4, n5, n6, n7, n8, n9, n10] = val.split('').map(x => Number.parseInt(x));
        return n10 === ((2*n1 + 4*n2 + 10*n3 + 3*n4 + 5*n5 + 9*n6 + 4*n7 + 6*n8 + 8*n9) % 11) % 10;
    }
    const errorMessage = message || 'ИНН должен состоять из 10 цифр';

    switch (true) {
        case isEmptyString(val):
            return undefined;
        case /^\d+$/.test(val.toString()) === false:
            return errorMessage;
        case val.toString().length !== 10:
            return errorMessage;
        case !isCorrectINN(val):
            return 'Не верный ИНН, проверьте расположение цифр';
        default:
            return val.toString().length === 10
                ? undefined
                : errorMessage;
    }
}

export function isIndividualInn(val, message) {
    const errorMessage = message || 'ИНН может содержать только 12 цифр';

    switch (true) {
        case isEmptyString(val):
            return undefined;
        case /^\d+$/.test(val.toString()) === false:
            return errorMessage;
        default:
            return val.toString().length === 12
                ? undefined
                : errorMessage;
    }
}

export function isCommonInn(val, message) {
    const errorMessage = message || 'ИНН может содержать только 10-12 цифр';

    switch (true) {
        case isEmptyString(val):
            return undefined;
        case /^\d+$/.test(val) === false:
            return errorMessage;
        default:
            return val.length >= 10 && val.length <= 12
                ? undefined
                : errorMessage;
    }
}

export function isCommonOgrn(val, message) {
    const errorMessage = message || 'ОГРН может содержать только 13-15 цифр';

    switch (true) {
        case isEmptyString(val):
            return undefined;
        case /^\d+$/.test(val) === false:
            return errorMessage;
        default:
            return val.length >= 13 && val.length <= 15
                ? undefined
                : errorMessage;
    }
}

export function isIndividualOgrn(val, message) {
    const errorMessage = message || 'ОГРН ИП может содержать только 15 цифр';

    switch (true) {
        case isEmptyString(val):
            return undefined;
        case /^\d+$/.test(val.toString()) === false:
            return errorMessage;
        default:
            return val.toString().length === 15
                ? undefined
                : errorMessage;
    }
}

export function isOgrn(val, message) {
    const errorMessage = message || 'ОГРН может содержать только 13 цифр';

    switch (true) {
        case isEmptyString(val):
            return undefined;
        case /^\d+$/.test(val.toString()) === false:
            return errorMessage;
        default:
            return val.toString().length === 13
                ? undefined
                : errorMessage;
    }
}

export function isKpp(val, message) {
    const errorMessage = message || 'КПП может содержать только 9 цифр';

    switch (true) {
        case isEmptyString(val):
            return undefined;
        case /^\d+$/.test(val.toString()) === false:
            return errorMessage;
        default:
            return val.toString().length === 9
                ? undefined
                : errorMessage;
    }
}

export function isBik(val, message) {
    const errorMessage = message || 'БИК может содержать только 9 цифр';
    return isKpp(val, errorMessage);
}

export function isPaymentAccount(val, message) {
    const errorMessage = message || 'Р / счет может содержать только 20 цифр';

    switch (true) {
        case isEmptyString(val):
            return undefined;
        case /^\d+$/.test(val.toString()) === false:
            return errorMessage;
        default:
            return val.toString().length === 20
                ? undefined
                : errorMessage;
    }
}

export function isCorrespondentAccount(val, message) {
    const errorMessage = message || 'К / счет может содержать только 20 цифр';
    return isPaymentAccount(val, errorMessage);
}

export function isMaxNumber(val, max, message) {
    return Number(val) <= Number(max)
        ? undefined
        : message;
}

export function isMinNumber(val, min, message) {
    return Number(val) >= Number(min) 
        ? undefined
        : message;
}

export function isDate(val, message) {
    const errorMessage = message || 'Введите дату в формате ДД/ММ/ГГГГ';

    switch (true) {
        case isEmptyString(val):
            return undefined;
        case /^\d{2}\/\d{2}\/\d{4}$/.test(val.trim()) === false:
        case moment(val.trim(), 'DD/MM/YYYY').isValid() === false:
        case moment().diff(moment(val.trim(), 'DD/MM/YYYY'), 'years') > 99:
            return errorMessage;
        default:
            return undefined;
    }
}

export function isDateWithoutDay(val, message) {
    const errorMessage = message || 'Введите дату в формате ММ/ГГГГ';

    switch (true) {
        case isEmptyString(val):
            return undefined;
        case /^\d{2}\/\d{4}$/.test(val.trim()) === false:
        case moment(val.trim(), 'MM/YYYY').isValid() === false:
        case moment().diff(moment(val.trim(), 'MM/YYYY'), 'years') > 99:
            return errorMessage;
        default:
            return undefined;
    }
}

export function isIssuingDate(date, message) {
    const errorMessage = message || 'Дата не может быть больше ' + moment().format('DD/MM/YYYY');
    switch (true) {
        case isEmptyString(date):
            return undefined;
        case isDate(date) !== undefined:
        case moment().diff(moment(date.trim(), 'DD/MM/YYYY'), 'hours') < 2:
            return errorMessage;
        default:
            return undefined;
    }
}

export function isMinDate(date, minDate, message) {
    const errorMessage = message || 'Дата не может быть меньше ' + minDate;

    switch (true) {
        case isEmptyString(date):
            return undefined;
        case isDate(minDate) !== undefined:
            return isDate(minDate);
        case isDate(date) !== undefined:
            return isDate(date);
        case moment(date.trim(), 'DD/MM/YYYY')
            .diff(moment(minDate.trim(), 'DD/MM/YYYY'), 'days') < 0:
            return errorMessage;
        default:
            return undefined;
    }
}

export function isSmsCode(val, message) {
    const errorMessage = message || 'Введите код из смс';

    switch (true) {
        case isEmptyString(val):
            return undefined;
        default:
            return /^\d\s\d\s\d\s\d$/.test(val)
                ? undefined
                : errorMessage;
    }
}

export function isChecked(val) {
    return val === true;
}

export function AgreementCheck(arr) {
    if (arr.length) {
        return undefined
    }
    return 'Подтвердите согласие с Лицензионным соглашения'
}


export function isDriverLicense(val, message) {
    const errorMessage = message || 'Поле должно содержать  10 символов в формате 00 АА 000000';
    switch (true) {
        case isEmptyString(val):
            return undefined;
        default:
            return /^\d{2}[0-9A-Za-zА-Яа-я]{2}[ ]\d{6}$/.test(val) ? undefined: errorMessage;
    }
}

export function isVehicleLicensePlate(val, message) {
    const errorMessage = message || 'Поле должно соответствовать формату А000АА000';
    switch (true) {
        case isEmptyString(val):
            return undefined;
        default:
            return /^[АВЕКМНОРСТУХ0-9]{1}\d{3}[АВЕКМНОРСТУХ0-9]{2}\d{2,3}$/.test(val) ? undefined: errorMessage;
    }
}
export function isVehicleRegistrationCertificate(val, message) {
    const errorMessage = message || 'Поле должно соответствовать формату АА АА 000000';
    switch (true) {
        case isEmptyString(val):
            return undefined;
        default:
            return /^[a-zA-Z0-9А-Яа-я]{2}[ ][a-zA-Z0-9А-Яа-я]{2}[ ]\d{6}$/.test(val) ? undefined: errorMessage;
    }
}

export function isVin (val, message) {
    const errorMessage = message || 'Поле должно состоять из 17 знаков (цифр и латинских символов)';
    switch (true) {
        case isEmptyString(val):
            return undefined;
        default:
            return /^[a-zA-Z0-9]{17}$/.test(val) ? undefined: errorMessage;
    }
}

export function isFilesLessThan(files = [], maxSize) {
    const errors = files.reduce((err, file) => {
        const errMes = file.size / 1024 / 1024 < maxSize
            ? undefined
            : `Файл превышает допустимый размер ${maxSize}мб`;

        if (errMes) {
            err[file.name] = errMes;
        }

        return err;
    }, {});

    return Object.keys(errors).length
        ? errors
        : undefined;
}

export function isFilesValidExtension(files = [], extensions) {
    const errors = files.reduce((err, file) => {
        const errMes = extensions.some((ext) =>
            (new RegExp(`\\.${ext}`, 'i')).test(file.name))
            ? undefined
            : 'Недопустимый формат файла';

        if (errMes) {
            err[file.name] = errMes;
        }

        return err;
    }, {});

    return Object.keys(errors).length
        ? errors
        : undefined;
}

export function validate(data, rules) {
    const errors = {};

    Object.keys(rules).map((field) => {
        const fieldRules = rules[field];

        if (!fieldRules) {
            return true;
        }

        fieldRules.every((rule) => {
            const ruleValidation = rule(data[field]);

            if (ruleValidation !== undefined && !errors.hasOwnProperty(field)) {
                errors[field] = ruleValidation;
                return false;
            }

            return true;
        });
    });

    return Object.keys(errors).length
        ? errors
        : undefined;
}



// WEBPACK FOOTER //
// ./src/services/validator.js